// extracted by mini-css-extract-plugin
export default {"ConfigurationValueField":"_ConfigurationValueField--haxSa","CustomConfiguration":"_CustomConfiguration--j8VXA","EditButton":"_EditButton--E741J","Label":"_Label--bdjo4"};